import React from 'react'
import { renderWithRoot } from '../common/react-root-helper'
import { getState, subscribe } from '../store'
import appActions from '../actions/app'
import { searchMessages } from './actions'
import App from '../common/app'
import Inbox from './components/index'
let unsubscribe = function () { }

function render() {

    renderWithRoot(
        <App {...getState()} {...appActions}>
            <Inbox {...getState()} {...appActions} changeSearchQuery={searchMessages} />
        </App>,
        document.querySelector('#app')
    )
}

export function enter(context, next) {
    unsubscribe = subscribe(render)
    searchMessages(getState().session.user.email, 1, 8, "byEmail", getState().session.user.email) 
    render()
}

export function exit(context, next) {
    unsubscribe()
    next()
}
